import {
  IHicapsConnectTerminal,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference } from '@principle-theorem/shared';

/**
 * A terminal the payment path has settled on, together with the practice that
 * owns it.
 *
 * Deliberately not a `WithRef<IHicapsConnectTerminal>`. A V2 terminal is
 * assembled from a terminal document, a merchant and a bridge edge, so there
 * is no single V1 terminal document behind it and therefore no honest `ref` to
 * hand over. Carrying the practice explicitly is what lets both models produce
 * one shape without a consumer having to walk a document path to find the
 * practice.
 */
export interface ISelectedHicapsConnectTerminal extends IHicapsConnectTerminal {
  practiceRef: DocumentReference<IPractice>;
}
